{
  "appName": "SmartAss AI",
  "actions": {
    "save": "Запази",
    "cancel": "Отказ",
    "delete": "Изтрий",
    "edit": "Редактирай",
    "create": "Създай",
    "submit": "Изпрати",
    "reset": "Нулиране",
    "search": "Търсене",
    "filter": "Филтър",
    "viewAll": "Виж всички",
    "viewDetails": "Виж детайли",
    "back": "Назад",
    "next": "Напред",
    "close": "Затвори",
    "confirm": "Потвърди",
    "loading": "Зареждане...",
    "retry": "Опитай отново"
  },
  "status": {
    "active": "Активен",
    "inactive": "Неактивен",
    "scheduled": "Планиран",
    "confirmed": "Потвърден",
    "pending": "Изчакващ",
    "inProgress": "В процес",
    "completed": "Завършен",
    "cancelled": "Отменен",
    "noShow": "Неявяване",
    "converted": "Конвертиран"
  },
  "errors": {
    "somethingWentWrong": "Съжаляваме, нещо се обърка",
    "pageNotFound": "Страницата не е намерена",
    "unauthorized": "Неоторизиран достъп",
    "networkError": "Грешка в мрежата. Моля, опитайте отново.",
    "unknown": "Неизвестна грешка"
  },
  "table": {
    "client": "Клиент",
    "service": "Услуга",
    "time": "Час",
    "status": "Статус",
    "location": "Местоположение",
    "actions": "Действия",
    "source": "Източник",
    "lastInteraction": "Последна комуникация",
    "noData": "Няма налични данни"
  },
  "copyright": "© {{year}} SmartAss AI. Всички права запазени.",
  "language": "Език",
  "or": "Или",
  "noContactInfo": "Няма данни за контакт",
  "anonymous": "Анонимен",
  "tbd": "Предстои",
  "signIn": "Вход",
  "userMenu": {
    "adminPanel": "Админ панел",
    "clientView": "Изглед за наемател",
    "customerView": "Изглед за потребител",
    "manage": "Управление",
    "dashboard": "Табло",
    "home": "Начало",
    "signOut": "Изход",
    "signingOut": "Излизане...",
    "logoutSuccess": "Успешно излизане",
    "profile": "Профил",
    "switchOrganization": "Превключи организация",
    "roleBadgeAdmin": "Администратор",
    "roleBadgeDeveloper": "Разработчик"
  },
  "ui": {
    "darkMode": {
      "dark": "Тъмен",
      "light": "Светъл",
      "switchToLight": "Превключи към светъл режим",
      "switchToDark": "Превключи към тъмен режим"
    },
    "autoRefresh": {
      "label": "Автоматично обновяване",
      "lastUpdated": "Последно: {{time}}",
      "on": "ВКЛ",
      "off": "ИЗКЛ"
    },
    "adminClientSelector": {
      "view": "Тенант:",
      "selectClient": "Изберете клиент"
    },
    "adminCompanySelector": {
      "view": "Компания:",
      "selectCompany": "Изберете компания",
      "allCompanies": "Всички компании"
    },
    "adminCustomerSelector": {
      "view": "Клиент:",
      "selectCustomer": "Изберете клиент"
    },
    "sidebar": {
      "expandSidebar": "Разшири страничната лента",
      "collapseSidebar": "Свий страничната лента"
    },
    "tenantSelector": {
      "title": "Изберете организация",
      "description": "Изберете организацията, до която искате да получите достъп:",
      "company": "Компания",
      "tenant": "Наемател",
      "tenantLevel": "Наемател (организация)",
      "companyLevel": "Компания (екип)",
      "preferred": "Предпочитан",
      "loadingOrganizations": "Зареждане на вашите организации...",
      "noOrganizationsTitle": "Няма намерени организации",
      "noOrganizationsDescription": "Все още нямате достъп до нито една организация. Моля, свържете се с вашия администратор.",
      "availableOrganizations": "Налични организации ({{count}})",
      "organizationHint": "Изберете наемател за широк достъп или компания за по-специфичен достъп. Йерархия: Наемател → Компания.",
      "selectToContinue": "Изберете вашата организация, за да продължите.",
      "cancel": "Отказ",
      "continue": "Продължи",
      "switchError": "Неуспешно превключване на организация. Моля, опитайте отново."
    }
  },
  "speechToText": {
    "voiceInput": "Гласов вход",
    "stopVoiceInput": "Спри гласовия вход",
    "listening": "Слушам...",
    "permissionDenied": "Необходим е достъп до микрофона. Моля, разрешете достъпа и опитайте отново.",
    "noSpeech": "Не е открита реч. Опитайте отново или въведете съобщението си.",
    "unsupported": "Гласовият вход не е наличен в този браузър"
  },
  "structuredNote": {
    "structureWithAi": "Структуриране с AI",
    "updateStructure": "Обновяване на AI структура",
    "editNote": "Редактиране на бележка",
    "originalNote": "Оригинална бележка",
    "structuredNote": "AI-структурирана бележка",
    "emptyStructured": "Все още няма структурирано съдържание.",
    "addItem": "Добавяне на елемент",
    "addNextStep": "Добавяне на следваща стъпка",
    "sections": {
      "keyTakeaways": "Ключови изводи / Бележки",
      "agreementsDecisions": "Споразумения / Решения",
      "nextSteps": "Следващи стъпки / Задачи"
    },
    "labels": {
      "responsible": "Отговорен",
      "deadline": "Краен срок"
    },
    "placeholders": {
      "keyTakeaway": "Въведете ключов извод...",
      "agreement": "Въведете споразумение или решение...",
      "task": "Задача",
      "responsible": "Отговорен (по избор)",
      "deadline": "Краен срок (по избор)"
    },
    "regenerateConfirm": {
      "title": "Замяна на структурираната бележка?",
      "message": "AI-структурираната бележка съдържа ръчни промени. Генерирането на нова структура може да ги замени. Искате ли да продължите?",
      "continue": "Продължи"
    },
    "loading": {
      "title": "Структуриране на бележката…",
      "description": "AI организира изводи, решения и следващи стъпки. Това може да отнеме няколко секунди."
    },
    "errors": {
      "generic": "Неуспешно структуриране на бележката. Моля, опитайте отново."
    }
  },
  "tenantInviteModal": {
    "title": "Генериране на линк за регистрация",
    "description": "Изберете роля за линка за покана. Потребителите, регистриращи се с този линк, ще получат избраната роля.",
    "roleLabel": "Роля",
    "roleRequired": "Моля, изберете роля",
    "rolePlaceholder": "Изберете роля",
    "roleTooltip": "Ролята, която ще бъде присвоена на потребителите при регистрация с този линк",
    "roleOwner": "Собственик",
    "roleEmployee": "Служител",
    "generateLink": "Генериране на линк",
    "cancel": "Отказ",
    "close": "Затваряне",
    "tokenSuccess": "Линк за покана е генериран",
    "tokenError": "Неуспешно генериране на линк: {{error}}",
    "successTitle": "Линк за покана е генериран",
    "successDescription": "Споделете този линк с лицето, което искате да поканите. Линкът изтича след 5 дни.",
    "linkDetails": "Детайли за линка",
    "inviteLink": "Линк за покана",
    "tenantRoleLabel": "Роля в тенанта",
    "clientIdLabel": "ID на клиент",
    "companyIdLabel": "ID на компания",
    "expiresAt": "Изтича на",
    "registrationUrl": "URL за регистрация",
    "copyRegistrationLink": "Копиране на линк за регистрация",
    "copyHint": "Копиране",
    "copied": "Копирано!",
    "copySuccess": "Линкът е копиран в клипборда",
    "securityNotice": "Съобщение за сигурност",
    "securityDescription": "Този URL за регистрация ще бъде показан само веднъж. Копирайте го преди да затворите. Всеки с този URL може да се регистрира и да се присъедини с указаната роля."
  },
  "tenantRoles": {
    "OWNER": {
      "label": "Собственик",
      "description": "Пълни права за управление: служители, настройки и покани"
    },
    "EMPLOYEE": {
      "label": "Служител",
      "description": "Оперативен достъп: срещи, лийдове и ресурси"
    },
    "CUSTOMER": {
      "label": "Клиент",
      "description": "Достъп до портала като клиент на този тенант; без членство във фирма"
    }
  },
  "relativeTime": {
    "justNow": "току-що",
    "minutes": "преди {{count}} мин",
    "hours": "преди {{count}} ч",
    "days": "преди {{count}} д",
    "months": "преди {{count}} мес",
    "years": "преди {{count}} г"
  }
}
